module.exports = __webpack_public_path__ + "static/media/annotationTask.2b775f6c.png";